import React from "react";
import { getPercentageFormatter } from "utilities/formatter";

interface Props {
  value: string
}

const ReadonlyPercentage = ({ value }: Props) => {
  const percentageFormatter = getPercentageFormatter(5);
  const formatted = percentageFormatter.format(Number.parseFloat(value) / 100);

  return <>{formatted}</>;
};

export default ReadonlyPercentage;